/**
 * Determines whether the press-origin guard should be disabled based on the device's input capabilities.
 *
 * On touch-only devices this function returns `true` indicating that the guard should be disabled
 * and a simple tap outside is sufficient for dismissal.
 *
 * On devices with hover and fine pointer support (e.g. mouse / track-pad) this returns `false`
 * This means that the guard should be enabled to avoid accidental dismissals from drag-release gestures
 *
 * This function utilizes feature-detection and not user agent sniffing
 * Feature Detection is recommended by (MDN)[https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/Browser_detection_using_the_user_agent#mobile_device_detection].
 */
export const shouldDisableDismissGuard = () => {
    if (typeof window === 'undefined')
        return false;
    const hasTouch = navigator.maxTouchPoints > 0;
    const supportsHover = window.matchMedia('(hover: hover)').matches;
    return hasTouch && !supportsHover;
};
//# sourceMappingURL=helpers.js.map